<ng-template [componentId]="{ componentId: 'me.family.performance', ids: familyIds }" let-res [loading]="loading" [error]="errorTemplate">
	<ng-container *ngIf="isPerformanceResponseValid && (isNetAndGrossDateEqual(res) || (customAdvisoryFee$ | async) === false); else errorTemplate">
		<mb-performance-table [data]="res" [familyId]="familyId" [customAdvisoryFee]="customAdvisoryFee$ | async"></mb-performance-table>
		<mb-inception-date [familyId]="familyId" [groupId]="groupId"></mb-inception-date>
		<ac-disclosure *ngIf="enableFamilySpecificDisclosure" [isExpandable]="false">
			<ng-container *ngIf="modelBenchmarkDisclaimer$ | async as modelBenchmarkDisclaimer; else familyIdentificationDisclaimerFallback">
				<span>{{ modelBenchmarkDisclaimer }}</span>
			</ng-container>
		</ac-disclosure>
		<ac-disclosure *ngIf="!enableFamilySpecificDisclosure" [isExpandable]="false"
			><span dcrHTMLKey="PERFORMANCE_TABLE_DISCLOSURE">PERFORMANCE_TABLE_DISCLOSURE</span></ac-disclosure
		>

		<ac-disclosure *ngIf="enablePerformancePageBottomDisclosure" [isExpandable]="false">
			<section *ngIf="(customAdvisoryFee$ | async) === false">
				<span dcrHTMLKey="NO_NET_PERF_DISCLOSURE">NO_NET_PERF_DISCLOSURE</span>
			</section>
			<span dcrHTMLKey="FAMILY_PERFORMANCE_DISCLOSURE_PREFIX"> </span>
			<!-- fund performance::: is on purpose, the full data string is model-family-type:group-name:family-ID but this page is for family only, so we can show the first 2 data as empty  -->
			<a target="_blank" [routerLink]="[appPaths.FUND_PERFORMANCE]" [queryParams]="{ familyId: familyId }" [attr.data-link-event]="'fund performance:::' + familyId">
				<span dcrHTMLKey="FAMILY_PERFORMANCE_DISCLOSURE_LINK"></span>
			</a>
			<span dcrHTMLKey="FAMILY_PERFORMANCE_DISCLOSURE_SUFFIX_1"> </span>
			<span
				*ngIf="(enablePerformanceBoxDisclosure && groupId !== blkFamilyGroup) || performanceBoxDisclosureEnabledBlkFamilies.includes(familyAladdinTicker$ | async)"
				dcrHTMLKey="FAMILY_PERFORMANCE_DISCLAIMER_BOX"
				>FAMILY_PERFORMANCE_DISCLAIMER_BOX</span
			>
			<span dcrHTMLKey="FAMILY_PERFORMANCE_DISCLOSURE_SUFFIX_2"> </span>
		</ac-disclosure>
		<mb-family-footer [showFundPerformanceLink]="false"></mb-family-footer>
	</ng-container>
</ng-template>

<ng-template #loading>
	<mb-performance-table-skeleton></mb-performance-table-skeleton>
</ng-template>

<ng-template #errorTemplate>
	<div dcrHTMLKey="PERFORMANCE_HOLDINGS_ERROR">The performance data is currently not available for this model</div>
</ng-template>

<ng-template #familyIdentificationDisclaimerFallback>
	<div [dcrHTMLKey]="familyIdentificationForDcr | async | slugify : '_' | uppercase"></div>
</ng-template>
